import React, { useState } from "react";
import {
  CardElement,
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { Button } from "@mantine/core";
import { baseURL, frontendURL } from "../../http";

const PaymentFormSkypoint = ({
  paymentIntentClientSecret,
  onPaymentSuccess,
  paymentoption,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState("");
  const [isComplete, setIsComplete] = useState(false);

  //   const paymentElementOptions=StripePaymentElementOptions = {
  //     layout: "tabs",
  //     paymentMethodOrder: paymentoption === 'card' ? ["card"] : ["ach"],
  //   };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsProcessing(true);

    try {
      const { error, paymentIntent, session_id } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${frontendURL}/success-skypoint`,
        },
      });

      if (error) {
        const errorUrl = `${frontendURL}/error-skypoint`;
        window.location.href = errorUrl;
      } else if (paymentIntent && paymentIntent.status === "succeeded") {
        const successUrl = `${frontendURL}/success-skypoint?payment_intent=${paymentIntent.id}&session_id=${session_id}`;
        window.location.href = successUrl;
      }
    } catch (err) {
      console.error("Payment failed:", err);
      setError("Payment failed. Please try again.");
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <form
    // onSubmit={handleSubmit}
    >
      <PaymentElement
        id="payment-element"
        onChange={(event) => {
          setIsComplete(event.complete);
        }}
      />
      {error && <div style={{ color: "red" }}>{error}</div>}
      <Button
        onClick={handleSubmit}
        disabled={!stripe || isProcessing || !isComplete}
      >
        {isProcessing ? "Processing..." : "Pay Now"}
      </Button>
    </form>
  );
};

export default PaymentFormSkypoint;
